module.exports = __webpack_public_path__ + "static/media/nz.6fdcdb95.png";